export default {
  title: 'Compartir esta carpeta Kimple',
  description: 'Puedes compartir esta carpeta Kimple sólo con las personas en tu red de escuela',
  share: 'Compartir',
  searchPlaceholder: 'Buscar por correo electrónico o nombre'
}

export const en = {
  title: 'Share this Kimple folder',
  description: 'You can share this Kimple folder only with people in your school network',
  share: 'Share',
  searchPlaceholder: 'Search by email or name'
}

export const ca = {
  title: 'Compartir aquesta carpeta Kimple',
  description: 'Només pots compartir aquesta carpeta Kimple amb les persones de la teva xarxa d\'escola',
  share: 'Compartir',
  searchPlaceholder: 'Cercar per email o nom'
}
